import { WeightUnit } from './intl';

/** Grams per unit — all conversions go through grams as the base */
const gramsPerUnit: Record<WeightUnit, number> = {
  [WeightUnit.Gram]: 1,
  [WeightUnit.Kilogram]: 1000,
  [WeightUnit.Ounce]: 28.3495,
  [WeightUnit.Pound]: 453.592,
};

/** Convert a weight value from one unit to another */
export function convertWeight(value: number, from: WeightUnit, to: WeightUnit): number {
  if (from === to) return value;
  const grams = value * gramsPerUnit[from];
  return grams / gramsPerUnit[to];
}

/**
 * Format a gram total for display as a compact page-level summary.
 * Values ≥ 1000 g render as `N.N kg`; values below 1000 g render as `N g`.
 * Used by the gear page stats bar and the shared gear view header; will be
 * reused by the pack editor and shared pack view.
 */
export function formatWeight(grams: number): string {
  if (grams >= 1000) return `${(grams / 1000).toFixed(1)} kg`;
  return `${Math.round(grams)} g`;
}

/**
 * Format a gram total in a caller-chosen display unit with explicit decimals.
 * Used wherever the profile's `defaultWeightUnit` / `defaultWeightDecimals`
 * should override the auto kg/g split — pack StatsBar, sidebar list, dashboard.
 */
export function formatWeightInUnit(grams: number, unit: WeightUnit, decimals: number = 1): string {
  const value = convertWeight(grams, WeightUnit.Gram, unit);
  return `${value.toFixed(decimals)} ${unit}`;
}
